// Service tier definitions for Sasha host (Bronze / Silver / Gold)
export const TIERS = [
  {
    id: "basic",
    name: "Bronze",
    tagline: "For the self-sufficient host",
    commission: "Free",
    description:
      "Foundational tools that keep your listing live, accurate and easy to manage on your own terms.",
    features: [
      "Listing setup & optimization",
      "Calendar & pricing tools",
      "Guest messaging templates",
      "24/7 traveler support",
      "Monthly performance report",
    ],
    highlighted: false,
  },
  {
    id: "standard",
    name: "Silver",
    tagline: "Our most chosen experience",
    commission: "15%",
    description:
      "A guided, hands-on partnership covering the day-to-day so you can step back without stepping away.",
    features: [
      "Everything in Bronze",
      "Dedicated host concierge",
      "Dynamic pricing strategy",
      "Professional photography",
      "Guest screening & vetting",
      "Quarterly portfolio review",
    ],
    highlighted: true,
  },
  {
    id: "premium",
    name: "Gold",
    tagline: "A bespoke, white-glove partnership",
    commission: "22%",
    description:
      "A complete, end-to-end stewardship with a tailored brand identity — including a property-branded avatar designed around your story.",
    features: [
      "Everything in Silver",
      "On-site property management",
      "Tailored brand & avatar design",
      "Linen, laundry & turnover service",
      "Maintenance & vendor coordination",
    ],
    highlighted: false,
  },
];

export const AMENITY_OPTIONS = [
  "Wi-Fi",
  "Air conditioning",
  "Heating",
  "Full kitchen",
  "Washer & dryer",
  "Private parking",
  "Pool",
  "Hot tub",
  "Fireplace",
  "Workspace",
  "Pet-friendly",
  "Sea view",
  "Garden / terrace",
  "EV charging",
];

export const PROPERTY_TYPES = [
  "Apartment",
  "House",
  "Villa",
  "Loft",
  "Cottage",
  "Cabin",
  "Studio",
  "Townhouse",
  "Boutique stay",
];
